import { render, staticRenderFns } from "./StateInformationNeeded.vue?vue&type=template&id=c10b1ee2&scoped=true&lang=html&"
import script from "./StateInformationNeeded.vue?vue&type=script&lang=coffee&"
export * from "./StateInformationNeeded.vue?vue&type=script&lang=coffee&"
import style0 from "./StateInformationNeeded.vue?vue&type=style&index=0&id=c10b1ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b1ee2",
  null
  
)

component.options.__file = "StateInformationNeeded.vue"
export default component.exports